module.exports = __webpack_public_path__ + "static/media/Roblox-Chinese-Logo-1557x537-White.5b95a56b.png";